import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import Button from "react-bootstrap/Button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Dots from "react-activity/lib/Dots";
import ModelsTable from "./modelsTable";
import ModelsForm from "./modelsForm";
import { getCurrentUser } from "../services/authService";
import { getById as getAircraft } from "../services/aircraftService";
import { getAircraftDetail as getModels } from "../services/aircraftDetailService";
import { saveModel, deleteModel } from "../services/aircraftModelsService";
import { getManufacturers } from "../services/manufacturerService";
import { getMediaList } from "../services/mediaService";
import { getScales } from "../services/scaleService";

class Models extends Component {
  state = {
    aircraft: {},
    models: [],
    manufacturers: [],
    media: [],
    scales: [],
    data: {
      manufacturer_id: 0,
      media_id: 0,
      scale_id: 0,
      kit_mold: "",
      kit_no: "",
    },
    user: {},
    loaded: true,
  };

  async componentDidMount() {
    this.setState({ loaded: false });

    if (this.props.location.state === undefined) return;

    const user = getCurrentUser();

    const aircraft_id = this.props.location.state.params;
    const aircraft = await getAircraft(aircraft_id);
    const models = await getModels(aircraft_id);
    const manufacturers = await getManufacturers();
    const media = await getMediaList();
    const scales = await getScales();

    this.setState({
      aircraft,
      models,
      manufacturers,
      media,
      scales,
      user,
      loaded: true,
    });
  }

  handleInputChange = (input) => {
    const { data } = this.state;
    data[input.name] = input.value;

    this.setState({ data });
  };

  handleModelDelete = async (model) => {
    const { aircraft } = this.state;

    await deleteModel(model.id);

    const models = await getModels(aircraft.aircraft_id);

    this.setState({ models });
  };

  handleAircraftSelect = () => {
    const { aircraft } = this.state;

    this.props.history.push(`/aircraft/details/${aircraft.aircraft_id}`);
  };

  handleShowManufacturer = (manufacturer_id) => {
    this.props.history.push(`/manufacturer/details/${manufacturer_id}`);
  };

  handleShowResults = () => {
    this.props.history.push("/aircraft/results");
  };

  handleNewAircraft = () => {
    this.props.history.push("/aircraft/add");
  };

  handleClearForm = () => {
    const data = {};
    data.manufacturer_id = 0;
    data.media_id = 0;
    data.scale_id = 0;
    data.kit_mold = "";
    data.kit_no = "";

    this.setState({ data });
  };

  handleFormSubmit = async () => {
    const { aircraft, data, user } = this.state;

    let model = {};
    model.aircraft_id = aircraft.aircraft_id;
    model.manufacturer_id = data.manufacturer_id;
    model.media_id = data.media_id;
    model.scale_id = data.scale_id;
    model.kit_mold = data.kit_mold;
    model.kit_no = data.kit_no;
    model.owner_id = user.id;

    await saveModel(model);

    const models = await getModels(aircraft.aircraft_id);

    let newdata = {};
    newdata.manufacturer_id = 0;
    newdata.media_id = 0;
    newdata.scale_id = 0;
    newdata.kit_mold = "";
    newdata.kit_no = "";
    this.setState({ data: newdata, models });
  };

  render() {
    const { aircraft, models, manufacturers, media, scales, data, loaded } =
      this.state;

    return loaded === false ? (
      <div className="dots_loader">
        <Dots size={26} />
      </div>
    ) : (
      <React.Fragment>
        <div className="row">
          <div className="col-8" style={{ backgroundColor: "white" }}>
            <h5 style={{ marginBottom: "20px" }}>
              <FontAwesomeIcon icon="plane" />
              <Button
                variant="link"
                size="lg"
                onClick={this.handleAircraftSelect}
              >
                &nbsp;Models for {aircraft.aircraft_name}
              </Button>
            </h5>
          </div>
          <div className="col-4" style={{ textAlign: "right" }}>
            {/* <Button variant="link" onClick={() => this.handleShowResults()}>Search Results</Button> */}
            <Button variant="link" onClick={() => this.handleNewAircraft()}>
              New Aircraft
            </Button>
          </div>
        </div>
        <ModelsForm
          data={data}
          manufacturers={manufacturers}
          media={media}
          scales={scales}
          onFormSubmit={this.handleFormSubmit}
          onInputChange={this.handleInputChange}
          onClearForm={() => this.handleClearForm()}
        />
        <ModelsTable
          data={models}
          onDelete={this.handleModelDelete}
          onShowManufacturer={this.handleShowManufacturer}
        />
      </React.Fragment>
    );
  }
}

export default withRouter(Models);
